'use strict';

exports.__esModule = true;
var assertCompatibility = exports.assertCompatibility = function assertCompatibility(options) {
  if (options.clientState && options.uriRealtime) {
    throw new Error('clientState is temporarily deprecated due to the issue: https://github.com/apollographql/apollo-link-state/issues/138');
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/graph-client/compatibility.js
// module id = 1175
// module chunks = 0